// extracted by mini-css-extract-plugin
module.exports = {"AuditReport":"styles_AuditReport__rqMe8","titles":"styles_titles__3lKpS","title":"styles_title__mtL9a"};